import {useCallback, useState} from "react";
import _ from "lodash";

/**
 * Custom hook to handle setting snapshot data within 3rd party libraries such as charting libraries where
 * we need (and has support for) handling events with custom data objects needing to be accessed in some sort of
 * temporal order whether by timestamp or index
 * @returns {{snapshotCallback: DebouncedFunc<handleSnapshot>, snapshotData: *[]}}
 */
export const useSnapshot = ()=>{
    const [snapshotData, setSnapshotData] = useState([]);
    const [snapshotDate, setSnapshotDate] = useState(null);

    const handleSnapshot = (point, date) => {
        try {
            const formattedData = Object.entries(point ?? {}).map(([key, value]) => ({
                key: key,
                wgt: value.wgt
            })).sort((a, b) => b.wgt - a.wgt);
            setSnapshotData(formattedData);
            setSnapshotDate(date);

        } catch (error) {
            console.error("Failed to handle snapshot:", error);
        }

    }
    // Debounce callback to avoid excessive firing due to usage being typically within a chart
    const snapshotCallback = useCallback(_.throttle(handleSnapshot, 100), []); // Throttle callback

    return {
        snapshotData, snapshotCallback, snapshotDate
    }

}
